import store from '../store'
import isLoading from './is-loading'
import requestShiftCopy from '../request/shift-copy'
import addError from './add-error'
import setModal from './set-modal'

export default (variables) => {
  return async (dispatch) => {
    if (!variables) return
    const { auth } = store.getState()

    await dispatch(isLoading('shift-copy'))
    const result = await requestShiftCopy(variables, auth)
    if (!result || result.error) {
      dispatch(addError(result.error))
    } else {
      await dispatch(setModal(null))
    }
    await dispatch(isLoading('shift-copy', true))
  }
}
